module.exports = __webpack_public_path__ + "static/media/inbox.71389802.svg";